import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import ContactUsContent from "../ones/ContactUsContent";
import Footer from "../ones/Footer";

export default function ContactUsLanding() {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <ContactUsContent />
        <Footer />
      </>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}

